import { IAddProductGoodsIssue } from "mobx-stores/_models/product-inventory/product-goods-issue/product-goods-issue";
import { IProductGoodsIssueItemProperties } from "mobx-stores/_models/product-inventory/product-goods-issue/product-goods-issue-item";
import { BaseBussiness } from "../base";

class ProductExportWarehouseBusiness extends BaseBussiness<
  IProductGoodsIssueItemProperties,
  IAddProductGoodsIssue,
  IAddProductGoodsIssue,
  IProductGoodsIssueItemProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }
}

export const productExportWarehouseBusiness =
  new ProductExportWarehouseBusiness("/api/app/product-warehouse-export");
